// extracted by css-extract-rspack-plugin
export default {"errorFallback":"ComposerFallback-module__errorFallback__T3rOy"};